<template>
    <div class="layout" :class="{mobile:mobile, 'view-only':viewOnly, 'iframeView':iframeView}">
        <div class="left-nav-cover" v-if="showController" @click="toggleShowController"></div>
        <div class="left-nav" :class="{collapse:collapseController, show:showController}" v-if="!viewOnly">
            <logo-img :small="collapseController"></logo-img>

            <div class="menu-con">
                <el-menu
                unique-opened
                :collapse="collapseController"
                @select="handleSelect"
                default-active="2">
                    <my-nav-menu :list="menuList"></my-nav-menu>
                </el-menu>
            </div>
        </div>
        <div class="top-nav" :class="{collapse:collapseController,'with-tag-nav':tagNav}" v-if="!viewOnly">
           
            <template v-if="mobile">
                <div class="btn-coll btn_top-nav" @click="toggleCollapse" v-if="!mobile">
                    <i :class="{'el-icon-s-fold':!collapseController,'el-icon-s-unfold':collapseController}"></i>
                </div>
                <div class="btn-coll btn_top-nav" @click="toggleCollapse" v-else>
                    <i class="el-icon-s-unfold"></i>
                </div>
            </template>
            <div class="btn-back btn_top-nav circle" @click="goBack">
                <i class="el-icon-back"></i>
            </div>

            <template>
                <my-breadcrumb></my-breadcrumb>

                <user-info :show.sync="hideBtnText"></user-info>

                <top-nav-right-btns></top-nav-right-btns>
            </template>

            <tag-nav v-if="tagNav"></tag-nav>
        </div>
        <div class="view" :class="{collapse:collapseController,'with-tag-nav':tagNav}" id="view-content">
            <router-view :key="$route.fullPath" />
        </div>
    </div>
</template>

<script>
import MyBreadcrumb from './components/breadcrumb'
import UserInfo from './components/user-info'
import LogoImg from './components/logo-img'
import TopNavRightBtns from './components/top-nav-right-btns'
import TagNav from './components/tag-nav'

export default {
    components: {MyBreadcrumb, UserInfo, LogoImg, TopNavRightBtns, TagNav},
    data () {
        return {
            collapseController: false,
            showController: false,

            mobile: false,
            viewOnly: false,
            tagNav: false,
            iframeView:false,
            hideBtnText:true,
            versionAccessTime:'',
        }
    },
    computed: {
        menuList() {
            var type = this.$store.state.system.system.type,
                sysStore = this.$store.state[type] || {};
            return sysStore.navList || [];
        }
    },
    methods: {
        queryMenu() {
            this.$get(this.getGetters('sysUrl') + '/menu/list', function (data) {
                this.menuList = data;
            })
        },
        toggleCollapse() {
            if(this.mobile) {
                this.toggleShowController();
                return;
            };
            this.collapseController = !this.collapseController;
        },
        toggleShowController() {
            this.showController = !this.showController;
        },
        goBack() {
            this.$router.go(-1);
        },
        resizeHandler() {
            if(window.innerWidth < 1000) {
                this.mobile = true;
            } else {
                this.mobile = false;
            };
        },
        checkFrameChild() {
            if(window !== window.top) {
                this.viewOnly = true;
            };
        },
        handleSelect(key, keyPath) {
            var linkArr = key.split(",")
            var pathUrl = linkArr[0]
            if(linkArr[1]=="企业采购"||pathUrl.indexOf("https://v.youku.com/v_show/id_XNDU2MzIzMDE0NA")!=-1||pathUrl.indexOf("http://121.28.5.194:9999")!=-1||pathUrl.indexOf("/zfcg/index.html")!=-1){
                // 新页面打开菜单
                window.open(pathUrl);
                return
            }else if(pathUrl.indexOf("/venuereservation")!=-1){
                // 判断是否包含问号
                if(pathUrl.indexOf("?") != -1){
                    pathUrl = pathUrl + '&t='+Math.random();
                }else{
                    pathUrl = pathUrl + '?t='+Math.random();
                }
                // 标室管理
                this.$store.commit('setBread', []);
                this.gotoFrame({
                    title:linkArr[1],
                    url: pathUrl,
                })
                return
            } if(pathUrl.indexOf("/dist/index.html")!=-1){
                // 判断是否包含问号
                if(pathUrl.indexOf("?") != -1){
                    pathUrl = pathUrl + '?t='+Math.random();
                }else{
                    pathUrl = pathUrl + '?t='+Math.random();
                }
                // 综合管理 专家抽取相关菜单
                this.$store.commit('setBread', []);
                this.gotoFrame({
                    title:linkArr[1],
                    url: pathUrl,
                })
            }else if(linkArr[1]=="监督通道"){
                // 新页面打开菜单
                window.open(pathUrl)
            }else{
                if(pathUrl.indexOf("#/") != -1){
                    var arr = pathUrl.split("#/");
                    var url = '/' + arr[1];
                    // 判断是否包含问号
                    if(url.indexOf("?") != -1){
                        url = url + '&t='+Math.random();
                    }else{
                        url = url + '?t='+Math.random();
                    }
                    this.goto({path: url});
                }else{
                    var lastUrlVal = this.$route.fullPath.split("url=")
                    if(pathUrl==unescape(lastUrlVal[1])){
                        return
                    }
                    
                    // 判断是否包含问号
                    if(pathUrl.indexOf("?") != -1){
                        pathUrl = pathUrl + '&t='+Math.random();
                    }else{
                        pathUrl = pathUrl + '?t='+Math.random();
                    }
                    this.$store.commit('setBread', []);
                    this.gotoFrame({
                        title:linkArr[1],
                        url:pathUrl,
                    })
                }
            }
            
        }
    },
    created() {
        var that = this;
        // 获取信息
        that.$store.dispatch('views/queryUserInfo');

        this.resizeHandler();
        window.addEventListener('resize', this.resizeHandler);

        this.checkFrameChild();
        
        if (self.frameElement && self.frameElement.tagName == "IFRAME") {
        　　this.iframeView = true
        }
        // 记录旧系统人数
        that.versionAccessTime = setTimeout(function () {
            that.$post(`${that.getGetters('mngUrl')}/v2/system/statistics/versionAccess.json`, {
                versionNum: 'v1',
            }, function (data, res) {
                
            })
        }, 180000);
        
    },
    mounted: function() {
        // this.$store.dispatch('views/queryUserInfo');
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.resizeHandler);
        // 清除定时器
        clearTimeout(this.versionAccessTime)
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>
